<script setup>
import { ref, inject } from "vue";
import { useStore } from "vuex";

const store = useStore();
const selectedDevices = inject("selectedDevices");

import BulkDevicesModal from "./Modals/AddBulkDevices.vue";
import SingleDeviceModal from "./Modals/AddSingleDevice.vue";
import ArchiveDevicesModal from "./Modals/ArchiveDevices.vue";
import UnassignDevicesModal from "./Modals/UnassignDevices.vue";
import UpdateDeviceModal from "./Modals/UpdateDevice.vue";
import MoveDevicesModal from "./Modals/MoveDevices.vue";

const showBulkDevicesModal = ref(false);
const showSingleDeviceModal = ref(false);
const showArchiveDevicesModal = ref(false);
const showUnassignDevicesModal = ref(false);
const showUpdateDevicesModal = ref(false);
const showMoveDevicesModal = ref(false);

const openBulkDevicesModal = () => {
  showBulkDevicesModal.value = true;
};

const openSingleDeviceModal = () => {
  showSingleDeviceModal.value = true;
};

const noDevicesWarning = () => {
  store.dispatch("toastNotification/displayToast", {
    message: "No device(s) selected.",
    type: "warning",
    duration: 1500,
  });
};

const ArchiveDevices = () => {
  if (selectedDevices.value.length === 0) {
    noDevicesWarning();
  } else {
    showArchiveDevicesModal.value = true;
  }
};

const UnassignDevices = () => {
  if (selectedDevices.value.length === 0) {
    noDevicesWarning();
  } else {
    showUnassignDevicesModal.value = true;
  }
};

const openUpdateDevicesModal = () => {
  if (selectedDevices.value.length === 0) {
    noDevicesWarning();
  } else if (selectedDevices.value.length > 1) {
    store.dispatch("toastNotification/displayToast", {
      message: "Select only one device.",
      type: "warning",
      duration: 1500,
    });
  } else {
    showUpdateDevicesModal.value = true;
  }
};

const openMoveDevicesModal = () => {
  if (selectedDevices.value.length === 0) {
    noDevicesWarning();
  } else {
    showMoveDevicesModal.value = true;
  }
};
</script>

<template>
  <div class="col-md-12">
    <BulkDevicesModal v-model="showBulkDevicesModal" />

    <SingleDeviceModal
      v-model="showSingleDeviceModal"
      @update:modelValue="showSingleDeviceModal = $event"
    />

    <ArchiveDevicesModal
      v-model="showArchiveDevicesModal"
      @update:modelValue="showArchiveDevicesModal = $event"
    />

    <UnassignDevicesModal
      v-model="showUnassignDevicesModal"
      @update:modelValue="showUnassignDevicesModal = $event"
    />

    <UpdateDeviceModal
      v-model="showUpdateDevicesModal"
      @update:modelValue="showUpdateDevicesModal = $event"
    />

    <MoveDevicesModal
      v-model="showMoveDevicesModal"
      @update:modelValue="showMoveDevicesModal = $event"
    />

    <div class="btn-group" style="margin-top: 12px">
      <button
        @click="openBulkDevicesModal"
        type="button"
        class="btn btn-success btn-sm"
      >
        BULK DEVICES
        <i class="fa fa-refresh fa-spin" style="display: none"></i>
      </button>
      <button
        @click="openSingleDeviceModal"
        type="button"
        class="btn btn-success btn-sm"
      >
        SINGLE DEVICE
        <i class="fa fa-refresh fa-spin" style="display: none"></i>
      </button>
      <button
        @click="ArchiveDevices"
        type="button"
        class="btn btn-danger btn-sm"
      >
        ARCHIVE DEVICES
        <i class="fa fa-refresh fa-spin" style="display: none"></i>
      </button>
      <button
        @click="UnassignDevices"
        type="button"
        class="btn btn-danger btn-sm"
      >
        UNASSIGN DEVICES
        <i class="fa fa-refresh fa-spin" style="display: none"></i>
      </button>
      <button
        @click="openUpdateDevicesModal"
        type="button"
        class="btn btn-warning btn-sm"
      >
        UPDATE DEVICE
        <i class="fa fa-refresh fa-spin" style="display: none"></i>
      </button>
      <button
        @click="openMoveDevicesModal"
        type="button"
        class="btn btn-warning btn-sm"
      >
        MOVE DEVICES
        <i class="fa fa-refresh fa-spin" style="display: none"></i>
      </button>
    </div>
  </div>
</template>
